/* Drawer-only progressive presentation. The existing picker engine owns data and links. */
(() => {
  'use strict';
  if (window.__smMobileGuidedR42) return;
  window.__smMobileGuidedR42 = true;
  const roots = new WeakMap();
  const hide = (node, value) => { if (node && node.hidden !== value) node.hidden = value; };
  function init(container) {
    if (roots.has(container)) { roots.get(container)(); return; }
    let picker = container.querySelector('.sm-mega');
    if (!picker) return;
    roots.set(container,schedule);
    const isVehicle = container.dataset.smGuided === 'vehicle';
    let progress = container.querySelector('[data-sm-progress]');
    let stepText = container.querySelector('[data-sm-step]');
    let selection = container.querySelector('[data-sm-selection]');
    // Resume validated complete selections restored by the existing engine.
    let override = null, frame = 0, signature = '';
    let displayedStep = 0, navigating = false;
    const query = s => picker.querySelector(s);
    const chosen = s => query(s)?.querySelector('button[aria-pressed="true"]')?.dataset.value || '';
    const value = s => query(s)?.value || '';
    function render() {
      frame = 0;
      if (!container.isConnected) return;
      // Header rendering may replace the summary or picker without replacing the container.
      picker = container.querySelector('.sm-mega');
      progress = container.querySelector('[data-sm-progress]');
      stepText = container.querySelector('[data-sm-step]');
      selection = container.querySelector('[data-sm-selection]');
      if (!picker || !progress || !stepText || !selection) return;
      const categoryButton = query('[data-sm-category-choices] button[aria-pressed="true"]');
      const category = categoryButton?.dataset.smCategoryChoice || '';
      const categoryTitle = categoryButton?.querySelector('.sm-mega__choice-label')?.textContent.trim() || category;
      const universal = ['decals','tools','accessory','apparel'].includes(category);
      const make = isVehicle ? chosen('[data-sm-makes]') : value('[data-sm-category-make]');
      const model = isVehicle ? chosen('[data-sm-models]') : value('[data-sm-category-model]');
      const year = isVehicle ? chosen('[data-sm-years]') : value('[data-sm-category-year]');
      const automatic = isVehicle ? (!make ? 0 : !model ? 1 : !year ? 2 : 3) : (!category ? 0 : universal ? 4 : !year ? 1 : !make ? 2 : !model ? 3 : 4);
      if (isVehicle && !navigating) override = automatic === 3 ? null : 0;
      const step = override === null ? automatic : Math.min(override, automatic);
      const compactVehicle = Boolean(make && model && year && (isVehicle ? step === 3 : step === 4 && !universal));
      container.dataset.smCompactVehicle = String(compactVehicle);
      displayedStep = step;

      // All portrait screens: Garage above the step heading,
      // visible only at the Make step.
      if (
        isVehicle &&
        window.matchMedia(
          '(orientation:portrait)'
        ).matches
      ) {
        const garage = container.querySelector(
          '[data-sm-vehicle-garage-trial]'
        );

        if (garage) {
          if (
            garage.parentElement !== progress.parentElement ||
            garage.nextElementSibling !== progress
          ) {
            progress.before(garage);
          }

          hide(garage, step !== 0);
        }
      }
      const names = isVehicle ? ['Choose a make','Choose a model','Choose a year','Browse products'] : ['Choose a category','Choose a year','Choose a make','Choose a model','Browse options'];
      const vehicleLabel = `${year} ${make} ${model}`;
      const vehiclePairs = compactVehicle ? [['Vehicle',vehicleLabel,isVehicle ? 0 : 1]] : (isVehicle ? [['Make',make,0],['Model',model,1],['Year',year,2]] : [['Year',year,1],['Make',make,2],['Model',model,3]]);
      const pairs = isVehicle ? vehiclePairs : [['Category',categoryTitle,0],...(!universal ? vehiclePairs : [])];
      hide(progress,false);
      const categoryPortraitSummary =
        !isVehicle &&
        compactVehicle &&
        window.matchMedia(
          '(orientation:portrait)'
        ).matches;

      const heading = compactVehicle
        ? (categoryPortraitSummary
            ? 'Your Selections'
            : 'Your vehicle')
        : `Step ${step + 1} · ${names[step]}`;

      const vehicleSummaryCard =
        isVehicle &&
        compactVehicle &&
        window.matchMedia('(orientation:portrait)').matches;

      container.dataset.smVehicleSummaryCard =
        String(vehicleSummaryCard);

      hide(stepText, vehicleSummaryCard);

      const summaryCaption = (label, text) =>
        vehicleSummaryCard && label === 'Vehicle'
          ? text
          : `${label}: ${text}`;

      if (stepText.textContent !== heading) {
        stepText.textContent = heading;
      }

      const nextSignature = JSON.stringify([
        step,
        pairs
      ]);

      const visiblePairs = pairs.filter(([,text,index]) => text && index < step);
      const rows = [...selection.children];
      const needsRepair = rows.length !== visiblePairs.length || visiblePairs.some(([label,text,index],i) =>
        rows[i]?.querySelector('span')?.textContent !== summaryCaption(label, text) ||
        rows[i]?.querySelector('[data-sm-change]')?.dataset.smChange !== String(index)
      );
      if (signature !== nextSignature || needsRepair) {
        signature = nextSignature;
        const fragment = document.createDocumentFragment();
        for (const [label, text, index] of pairs) {
          if (!text || index >= step) continue;
          const row = document.createElement('div'); row.className = 'sm-mobile-selected-row';
          const caption = document.createElement('span');
          caption.textContent = summaryCaption(label, text);
          const change = document.createElement('button'); change.type = 'button'; change.dataset.smChange = String(index); change.textContent = 'Change'; change.setAttribute('aria-label',`Change ${label.toLowerCase()}`);
          row.append(caption, change);
          fragment.append(row);
        }
        selection.replaceChildren(fragment);
      }
      if (isVehicle) {
        ['[data-sm-makes]','[data-sm-models]','[data-sm-years]','[data-sm-categories]'].forEach((s,index) => hide(query(s)?.closest('.sm-mega__column'),index !== step));
      } else {
        hide(query('[data-sm-category-choices]')?.closest('.sm-mega__category-column'),step !== 0);
        hide(query('[data-sm-category-vehicle-column]'), universal || step < 1 || step > 3);
        hide(query('[data-sm-category-vehicle]'), universal || step < 1 || step > 3);
        const ymmSelectors = [
          '[data-sm-category-year]',
          '[data-sm-category-make]',
          '[data-sm-category-model]'
        ];

        // Keep the existing one-dropdown-at-a-time behavior.
        ymmSelectors.forEach((selector, index) => {
          hide(
            query(selector)?.closest('label'),
            step !== index + 1
          );
        });

        const portraitYMM = window.matchMedia(
          '(max-width:749px) and (orientation:portrait)'
        ).matches;

        const ymmFields = query('.sm-mega__ymm-fields');
        let ymmSteps = query('[data-sm-ymm-steps]');

        if (portraitYMM && ymmFields) {
          if (!ymmSteps) {
            ymmSteps = document.createElement('div');
            ymmSteps.dataset.smYmmSteps = '';
            ymmSteps.setAttribute(
              'role',
              'group'
            );
            ymmSteps.setAttribute(
              'aria-label',
              'Vehicle selection steps'
            );
            ymmSteps.style.cssText =
              'display:flex;align-items:center;gap:10px;' +
              'margin:0 0 4px;';
            ['Year', 'Make', 'Model'].forEach((name, index) => {
              if (index > 0) {
                const separator = document.createElement('span');
                separator.textContent = '·';
                separator.setAttribute('aria-hidden', 'true');
                separator.style.cssText =
                  'color:#777;font-size:15px;line-height:1.4;' +
                  'flex:0 0 auto;';
                ymmSteps.append(separator);
              }

              const button = document.createElement('button');
              button.type = 'button';
              button.textContent = name;
              button.dataset.smChange = String(index + 1);
              button.setAttribute('aria-label', 'Choose ' + name);
              ymmSteps.append(button);
            });

            ymmFields.prepend(ymmSteps);
          }

          ymmSteps.hidden = false;

          [...ymmSteps.querySelectorAll('button')].forEach((button, index) => {
            const field = query(ymmSelectors[index]);
            const active = step === index + 1;
            const available = Boolean(field && !field.disabled);

            button.disabled = !available;
            button.style.cssText =
              'appearance:none;border:0;background:transparent;' +
              'padding:4px 0;margin:0;font:inherit;' +
              'font-size:15px;font-weight:600;line-height:1.4;' +
              'opacity:1;' +
              'color:' + (active ? '#fff' : '#777') + ';' +
              'cursor:' + (available ? 'pointer' : 'not-allowed') + ';';

            if (active) {
              button.setAttribute('aria-current', 'step');
            } else {
              button.removeAttribute('aria-current');
            }
          });
        } else if (ymmSteps) {
          ymmSteps.hidden = true;
        }
        hide(query('[data-sm-category-options]')?.closest('.sm-mega__category-column'),step !== 4);
      }
      // Portrait Category footer follows the visible category step.
      if (!isVehicle) {
        const categoryFooter = query('[data-sm-category-status]');

        const choosingCategory =
          step === 0 &&
          window.matchMedia(
            '(max-width:749px) and (orientation:portrait)'
          ).matches;

        if (categoryFooter) {
          if (choosingCategory) {
            if (categoryFooter.textContent !== 'Choose a category') {
              categoryFooter.dataset.smCategoryFooterOriginal =
                categoryFooter.textContent;

              categoryFooter.textContent = 'Choose a category';
            }
          } else if (
            categoryFooter.dataset.smCategoryFooterOriginal !== undefined
          ) {
            if (categoryFooter.textContent === 'Choose a category') {
              categoryFooter.textContent =
                categoryFooter.dataset.smCategoryFooterOriginal;
            }

            delete categoryFooter.dataset.smCategoryFooterOriginal;
          }
        }
      }

      container.dataset.smGuidedReady = 'true';
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(render); }
    container.addEventListener('click',event => {
      if (!(event.target instanceof Element)) return;
      const change = event.target.closest('[data-sm-change]');
      if (change) { navigating = true; override = Number(change.dataset.smChange); render(); return; }
      if (event.target.closest('.sm-mega__choice')) {
        // Advance one step even if the customer taps the remembered choice again.
        navigating = true;
        override = isVehicle ? Math.min(displayedStep + 1, 3) : null;
        schedule();
      }
    });
    container.addEventListener('change',() => {
      override = null;
      schedule();
    });

    container.addEventListener('sm:garage-selected',() => {
      override = null;
      navigating = false;
      schedule();
    });
    // Native select updates and async product rendering can occur after a click.
    const observer = new MutationObserver(schedule);
    observer.observe(container,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-pressed']});
    const groupDetails = container.closest('details');
    groupDetails?.addEventListener('toggle',() => {
      if (!groupDetails.open) return;
      const drawer = container.closest('header-drawer');
      drawer?.querySelectorAll('.sm-mobile-group > accordion-custom > details[open]').forEach(other => {
        if (other !== groupDetails) { other.open = false; other.querySelector('summary')?.setAttribute('aria-expanded','false'); }
      });
      schedule();
    });
    render();
  }
  function scan() { document.querySelectorAll('header-drawer [data-sm-guided]').forEach(init); }
  let scanFrame = 0;
  const pageObserver = new MutationObserver(records => {
    if (!records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-sm-guided],header-drawer') || n.querySelector?.('[data-sm-guided]'))))) return;
    if (!scanFrame) scanFrame = requestAnimationFrame(() => { scanFrame = 0; scan(); });
  });
  function start() { scan();pageObserver.observe(document.body,{childList:true,subtree:true}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',scan);
  window.addEventListener('pageshow',scan);
})();
